module.exports = __webpack_public_path__ + "media/images/riders/BARBARA_BENKO-2fdf4dbff843284660eed8ef51e974c0.png";